<template>
  <div>
    <div class="head">
      <div class="headLogo" @click="$router.push('/')">
        <img class="headLogo_img" src="../../static/img/logo.png" alt="" />
      </div>
      <div class="ut">Mfo Eckz, Too</div>
    </div>
    <!-- 中间内容 -->
    <div class="minu">
      <div>
        <div class="minu_title">Персональная информация</div>
        <el-form :inline="false" :model="formInline" ref="formInline" :rules="rules" :validate-on-rule-change="false">
          <!-- 月收入 -->
          <el-form-item prop="month_income">
            <el-select v-model="formInline.month_income" placeholder="Ваш ежемесячный доход" class="demo-form-inline">
              <el-option v-for="(item,index) in month_income" :value="index" :label="item" :key="index" class="demo-form-inlineoptio"></el-option>
            </el-select>
          </el-form-item>
          <!-- 教育水平 -->
          <el-form-item prop="education">
            <el-select v-model="formInline.education" placeholder="Уровень образования" class="demo-form-inline">
              <el-option v-for="(item,index) in education" :value="index" :label="item" :key="index" class="demo-form-inlineoptio"></el-option>
            </el-select>
          </el-form-item>
          <!-- 就业类型 -->
          <el-form-item prop="job_type">
            <el-select v-model="formInline.job_type" placeholder="Вид занятости" class="demo-form-inline">
              <el-option v-for="(item,index) in job_type" :value="index" :label="item" :key="index" class="demo-form-inlineoptio"></el-option>
            </el-select>
          </el-form-item>
          <!-- 贷款目的 -->
          <el-form-item prop="loan_purpose">
            <el-select v-model="formInline.loan_purpose" placeholder="Цель кредита" class="demo-form-inline">
              <el-option v-for="(item,index) in loan_purpose" :value="index" :label="item" :key="index" class="demo-form-inlineoptio"></el-option>
            </el-select>
          </el-form-item>
          <!-- 电子邮件 -->
          <el-form-item class="demo-form-inline" prop="email">
            <el-input v-model="formInline.email" placeholder="Электронная почта" class="demo-form-inlineoptio"></el-input>
          </el-form-item>
          <!-- 家庭住址 -->
          <el-form-item prop="address">
            <el-select  @change="addressstreetFn" v-model="formInline.address" placeholder="Домашний адрес" class="demo-form-inline">
              <el-option v-for="(item,index) in address" :value="item" :label="item.length > 25 ? item.slice(0,25) + '...' : item" :key="index" class="demo-form-inlineoptio">{{item}}</el-option>
            </el-select>
          </el-form-item>
          <!-- 街道 -->
          <el-form-item prop="address_street">
            <el-select v-model="formInline.address_street" placeholder="Улица" class="demo-form-inline">
              <el-option v-for="(item,index) in address_street" :value="item.ename" :label="item.ename.length > 25 ? item.ename.slice(0,25) + '...' : item.ename" :key="index" class="demo-form-inlineoptio">{{item.ename}}</el-option>
            </el-select>
          </el-form-item>
          <!-- 详细地址 -->
          <el-form-item prop="detail_arer" style="margin-bottom: 0.21rem;">
            <el-input v-model="formInline.detail_arer" placeholder="Подробный адрес"></el-input>
          </el-form-item>
        </el-form>
        <div class="demo-form-btn" @click="onSubmit('formInline')">продолжать</div>
      </div>
    </div>
    <!-- 底部协议 -->
    <div class="bom">
      <div class="bom_con">
        <div class="bom_con-text">Адрес:Казахстан, город Алматы, Бостандыкский район,улица Еділ Ерғожин, здание 27, 46</div>
        <div class="bom_minuIm">
          <div class="bom_con-num">Скачивай мобильное приложение через:</div>
          <div class="bom_minuIm">
            <img class="bom_img" style="margin-right: 0.1rem;" src="../../static/img/googleplay.png" alt=""
              @click="googleFn" />
            <img class="bom_img" src="../../static/img/AppStore.png" alt="" @click="appstoreFn" />
          </div>
        </div>
      </div>
      <div class="bom_mi">
        <div class="bom_mi-text">Понедельник-пятница 9:00 - 21:00 Суббота-воскресенье 11:00 - 21:00</div>
        <div class="bom_mi-tit">ТОО «МФО ECKZ», Лицензия на осуществление микрофинансовой деятельности № 02.24.0011.М,
          от 12.09.2024 года, выдана Управлением региональных представителей в городе Алматы Агентства Республики
          Казахстан по регулированию и развитию финансового рынка.</div>
      </div>
    </div>
  </div>
</template>

<script>
  import locations from '@/utils/location.js'
  import {
    userInfo
  } from '@/api/info'
  export default {
    name: "personal",
      data() {
        return {
           //收入
          month_income: [
          	'Менее 70 000',
          	'70000-100000',
          	'100000-200000',
          	'200000-300000',
          	'300000-400000',
          	'400000-500000',
          	'больше 500000'
          ],
          // 教育水平
          education: [
          	'Среднее',
          	'Среднее специальное',
          	'Высшее образование',
          	'Научная степень',
          	'Второе Высшее'
          ],
          // 就业类型
          job_type: [
						'Рабочий',
						'Предприниматель',
						'Пенсионер',
						'Студент',
						'Неполная занятость',
						'Я не работаю'
					],
          // 贷款目的
          loan_purpose:[
            'Покупка',
            'Обучение',
            'Личное потребление',
            'Досуг и развлечения',
            'Неотложные потребности',
            'Лечение',
            'Погашение других кредитов'
          ],
          address: [],
          address_street: [],
          formInline: {
            month_income: '',
            education: '',
            job_type: '',
            loan_purpose: '',
            email: '',
            address: '',
            address_street: '',
            detail_arer: ''
          },
          locationData: [],//地址列表
          rules: {
             month_income: [
               { required: true, message: 'Пожалуйста, выберите свой ежемесячный доход!', trigger: 'change' }
             ],
             education: [
               { required: true, message: 'Пожалуйста, выберите уровень вашего образования!', trigger: 'change' }
             ],
             job_type: [
               { required: true, message: 'Пожалуйста, выберите тип занятости!', trigger: 'change' }
             ],
             loan_purpose: [
               { required: true, message: 'Пожалуйста, выберите цель кредита!', trigger: 'change' }
             ],
             email: [
               { required: true, message: 'Пожалуйста, введите адрес электронной почты!', trigger: 'blur' },
               { type: 'email', message: 'Неверный формат. Пример правильного формата:' + 'fcreditKz@gmail.com', trigger: ['blur', 'change']}
             ],
             address: [
               { required: true, message: 'Пожалуйста, выберите свою область или город!', trigger: 'change' }
             ],
             address_street: [
               { required: true, message: 'Пожалуйста, выберите свою улицу!', trigger: 'change' }
             ],
             detail_arer: [
               { required: true, message: 'Пожалуйста, введите свой полный адрес!', trigger: 'blur' }
             ]
           },
           flage: false
        }
      },
      mounted() {
      	this.arerFn()
      },
      methods: {
        arerFn(){
        	// 获取一级地址
        	this.locationData = locations
        	let searchLocationData = []
        	for(let i = 0; i < this.locationData.length; i++){
        		for (let j = 0; j < this.locationData[i].addressName.length; j++) {
        			this.address.push(this.locationData[i].addressName[j].ename)
        		}
        	}
        },
        addressstreetFn(){
          // 获取二级地址
          if(this.formInline.address != ''){
          	for(let i = 0; i < this.locationData.length; i++){
          		for (let j = 0; j < this.locationData[i].addressName.length; j++) {
          			if(this.locationData[i].addressName[j].ename == this.formInline.address){
          				this.address_street = this.locationData[i].addressName[j].addressName
          			}
          		}
          	}
          }
        },
        onSubmit(formName) {
          if(this.flage) return
          this.flage = true
          this.$refs[formName].validate((valid) => {
            if (valid) {
                var parameter = {
                  month_income: this.formInline.month_income + 1,
                  education: this.formInline.education + 1,
                  job_type: this.formInline.education + 1,
                  loan_purpose: this.formInline.loan_purpose + 1,
                  email: this.formInline.email,
                  address: this.formInline.address + '/' + this.formInline.address_street + '/' + this.formInline.detail_arer,
                  step: 11
                }
                userInfo(parameter).then(res => {
                  if(res.data.status != 0){
                    this.flage = false
                    this.$message.error({
                      message: res.data.remark || 'Отправка не удалась'
                    });
                  }else{
                    this.flage = false
                    this.$router.push('/contact')
                  }
                })
              } else {
                this.flage = false
                console.log('error submit!!');
                return false;
              }
          });
        },
        googleFn() {
          location.href =
            'https://play.google.com/store/apps/details?id=express.credit.fast.tez.loan.money.cash.pay.bank.card'
        },
        privacyFn() {
          location.href = 'https://mfoeckz.com/privacy.html'
        },
        BasicRulesFn() {
          location.href = 'https://mfoeckz.com/BasicRules.pdf'
        },
        contractFn() {
          location.href = 'https://mfoeckz.com/contract.pdf'
        },
        appstoreFn() {
          location.href = 'https://apps.apple.com/kz/app/%D0%B1%D1%8B%D1%81%D1%82%D1%80%D1%8B%D0%B9-%D0%B7%D0%B0%D0%B9%D0%BC/id6751275518'
        }
      }
    }
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
    border: none;
    Outline: none;
  }

  .head {
    padding: 0.1rem 1.88rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .headLogo {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .demo-form-inlineoptio{
    margin-bottom: 0.12rem;
  }

  .headLogo_img {
    width: 0.27rem;
    height: 0.27rem;
    cursor: pointer;
  }

  .ut{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    font-style: normal;
  }
  .minu {
    border-top: 0.01rem solid #C0C0C0;
    padding-top: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1.31rem;
  }
  .minu_title{
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.17rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.27rem;
  }
  .demo-form-inline{
    width: 2.81rem;
  }
  .el-select-dropdown__item{
    padding: 0 0.12rem;
  }
 /deep/ .el-form .el-form-item {
     margin-bottom: 0.1rem;
  }

  /deep/ .el-form-item__error {
    width: 10rem !important;
    color: #F56C6C;
    font-size: 12px;
    padding-top: 2px;
    margin-bottom: 12px !important;
  }
  .demo-form-btn{
    width: 2.81rem;
    height: 0.29rem;
    line-height: 0.29rem;
    text-align: center;
    background: #D4AF37;
    border-radius: 0.15rem;
    font-family: SFProText, SFProText;
    font-weight: bold;
    font-size: 0.1rem;
    color: #FFFFFF;
    font-style: normal;
    cursor: pointer;
  }

  /* 底部 */
  .bom {
    background: #F9F9F9;
    padding: 0.52rem 1.88rem;
  }

  .bom_con {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.31rem;
  }

  .bom_con-text {
    width: 2.76rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
  }

  .bom_minuIm {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bom_con-num {
    width: 1.1rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
    margin-right: 0.15rem;
  }

  .bom_img {
    width: 0.71rem;
    height: 0.21rem;
  }
  .bom_mi{
    display: flex;
    flex-direction: row;
  }
  .bom_mi-text{
    width: 1.78rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
    margin-right: 0.4rem;
  }
  .bom_mi-tit{
    width: 4rem;
    height: 0.38rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #333333;
    line-height: 0.13rem;
    font-style: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/personal.vue